// Czytaj dalej rozswanie konetentu dla sekcji "o mnie" i "oferta"
document.addEventListener("DOMContentLoaded", function(event) {
    var readMoreAboutMe = document.querySelector('.about-me .read-more');
    var moreContentAboutMe = document.querySelector('.about-me .more-content');
    var readMoreTextAboutMe = document.querySelector('.about-me .read-more span');
    var readMoreSVGTextAboutMe = document.querySelector('.about-me .read-more svg');

    readMoreAboutMe.addEventListener('click', function(){
        if (moreContentAboutMe.classList.contains('visible')){
            // if (window.matchMedia("(max-width: 767px)").matches) {
            //     var visibleElement = document.querySelector('.about-me__text .more-content.visible');
            //     visibleElement.style.maxHeight = '';
            // }
            moreContentAboutMe.classList.remove('visible');
            readMoreTextAboutMe.innerHTML = "Czytaj dalej";
            readMoreSVGTextAboutMe.style.transform = "rotate(0deg)"
        } else {
            moreContentAboutMe.classList.add('visible');
            // if (window.matchMedia("(max-width: 767px)").matches) {
            //     var visibleElement = document.querySelector('.about-me__text .more-content.visible');
            //     var firstPara = $('.about-me__text .more-content p')[0].offsetHeight;
            //     var secondPara = $('.about-me__text .more-content p')[1].offsetHeight;
            //     var maxHeighttt = firstPara + secondPara + 16;
            //     console.log(visibleElement);
            //     visibleElement.style.maxHeight = maxHeighttt + 'px';
            // }
            readMoreTextAboutMe.innerHTML = "Zwiń";
            readMoreSVGTextAboutMe.style.transform = "rotate(180deg)"
        }
    })

    
    var readMoreOffer = document.querySelector('#offer .read-more');
    var moreContentOffer = document.querySelector('#offer .more-content');
    var readMoreTextOffer = document.querySelector('#offer .read-more span');
    var readMoreSVGTextOffer = document.querySelector('#offer .read-more svg');

    readMoreOffer.addEventListener('click', function(){
        if (moreContentOffer.classList.contains('visible')){
            moreContentOffer.classList.remove('visible');
            readMoreTextOffer.innerHTML = "Czytaj dalej";
            readMoreSVGTextOffer.style.transform = "rotate(0deg)"
        } else {
            moreContentOffer.classList.add('visible');
            readMoreTextOffer.innerHTML = "Zwiń";
            readMoreSVGTextOffer.style.transform = "rotate(180deg)"
        }
    })
});

var animationStop = false;

// FixedMenu 
document.addEventListener('DOMContentLoaded', function () {
	if (window.matchMedia("(min-width: 992px)").matches) {
        var menu = document.querySelector('#menu');
        var sliderStatic = document.querySelector('#slider-static');
    
            // console.log(menuPositionY);
            document.addEventListener('scroll', function () {
                    var menuPositionY = menu.offsetTop;
                    // console.log(pageYOffset);
                    if(animationStop === false){
                        if(pageYOffset >= 269){
                            menu.classList.add('fixed-top');
                            // sliderStatic.style.paddingTop = menu.getBoundingClientRect().height;
                        }
                        else {
                            menu.classList.remove('fixed-top');
                            // sliderStatic.style.paddingTop = "20rem";
                        }
                    }

            });
    }
})


// smooth scroll
jQuery("#slider-static a").click(function(event) {
    jQuery('html, body').animate({
        scrollTop: jQuery("#about-me").offset().top
    }, 800);
 });


jQuery("#menu .logo").click(function(event) {
    event.preventDefault();
    animationStop = true;
    jQuery('html, body').animate({
        scrollTop: jQuery("#logo").offset().top
    }, 800);
    setTimeout( () => {
        animationStop = false;
    }, 100);
 });

 jQuery("#menu .about-me").click(function(event) {
    event.preventDefault();
    animationStop = true;
    jQuery('html, body').animate({
        scrollTop: jQuery("#about-me").offset().top
    }, 800);
    
    setTimeout( () => {
        animationStop = false;
    }, 100 );
 });

 jQuery("#menu .offer").click(function(event) {
    event.preventDefault();
    animationStop = true;
    jQuery('html, body').animate({
        scrollTop: jQuery("#offer").offset().top
    }, 800);
    setTimeout( () => {
        animationStop = false;
    }, 100 );
 });

 jQuery("#menu .references").click(function(event) {
    event.preventDefault();
    animationStop = true;
    jQuery('html, body').animate({
        scrollTop: jQuery("#references").offset().top + 10
    }, 800);
    setTimeout( () => {
        animationStop = false;
    }, 100 );
 });

jQuery("#menu .footer-bottom").click(function(event) {
    event.preventDefault();
    animationStop = true;
    jQuery('html, body').animate({
        scrollTop: jQuery("#footer-bottom").offset().top
    }, 800);
    setTimeout( () => {
        animationStop = false;
    }, 100 );
 });


 // animacje
import AmazingScroll from './modules/amazingScroll.js';
document.addEventListener("DOMContentLoaded", function () {
    if (window.matchMedia("(min-width: 992px)").matches) {
        window.animate = AmazingScroll({
            start: {
                visibleAfterLoading: true,
                waitForScroll: {
                    on: false,
                    ratio: 0
                }
            },
            animation: {
                "fade-left": "left:-2300px->0; transition:all 0s->all 2s;",
                "fade-right": "right:-2300px->0; transition:all 0s->all 2s;",
                "fade-top-brands": "position:relative; top:-100px->0; transition:all 0s->all 1s; opacity:0->0.85;",
                "fade-top": "position:relative; top:-100px->0; transition:all 0s->all 1s; opacity:0->1;",
                "fade-top-2": "position:relative; top:-100px->0; transition:all 0s->all 1s 0.2s; opacity:0->1;",
                "fade-top-4": "position:relative; top:-100px->0; transition:all 0s->all 1s 0.4s; opacity:0->1;",
                "opacity": "opacity:0->1; transition:all 0s->all 2s",
                "opacity-2": "opacity:0->1; transition:all 0s->all 1s 0.2s",
                "opacity-4": "opacity:0->1; transition:all 0s->all 1s 0.4s",
                "scale": "transform:scale(0)->scale(1); transition:all 1s; opacity:0->1;"
            }
        });
    }
});


 // cookies
 document.addEventListener("DOMContentLoaded", function () {
     var closeCookieButton = document.querySelector('.cookies .turn-off');
     var cookiesElement = document.querySelector('.cookies');

     closeCookieButton.addEventListener('click', function(){
        cookiesElement.style.opacity = "0";
     });
 });

document.addEventListener('DOMContentLoaded', function () {
    var cookiesElement = document.querySelector('.cookies');
    if (getCookie('hideCookie') != 1) {
        cookiesElement.style.opacity = "1";
    } else{
        cookiesElement.style.opacity = "0";
    }
});


// add class to body if ie
(function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        var ieV = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        document.querySelector('body').className += ' IE';
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        var ieV = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        document.querySelector('body').className += ' IE';
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
       // IE 12 (aka Edge) => return version number
       var ieV = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        document.querySelector('body').className += ' IE';
    }

    // other browser
    return false;
})();


// WEBPACK FOOTER //
// ./src/js/index.js